import { createContext, useState } from 'react'

export const ChangeComponentContext = createContext()

export const ChangeComponentProvider = ({ children }) => {
    const [showComponent, setShowComponent] = useState('abaWeb-tratarEvento')
    const [killComponent, setKillComponent] = useState('')

    const createConfig = (component) => {
        const componentCapitalized = component.split('')[0].toUpperCase() + component.slice(1)
        const show = `show${componentCapitalized}`
        const kill = `kill${componentCapitalized}`

        return {
            [show]: showComponent.includes(component),
            [kill]: killComponent.includes(component)
        }
    }

    const { showAbaWeb, killAbaWeb } = createConfig('abaWeb')
    const { showEntregasTab, killEntregasTab } = createConfig('EntregasTab')
    const { showTratarEvento, killTratarEvento } = createConfig('tratarEvento')
    const { showLivroAta, killLivroAta } = createConfig('livroAta')
    const { showOrdemServico, killOrdemServico } = createConfig('ordemServico')
    const { showHistoricoEventos, killHistoricoEventos } = createConfig('historicoEventos')
    const { showAcessosAoVivo, killAcessosAoVivo } = createConfig('acessosAoVivo')
    const { showNobreak, killNobreak } = createConfig('nobreak')
    const { showCaixaAgua, killCaixaAgua } = createConfig('caixaAgua')
    const { showVisitantes, killVisitantes } = createConfig('visitantes')
    const { showOcorrencias, killOcorrencias } = createConfig('ocorrencias')
    const { showRonda, killRonda } = createConfig('ronda')
    const { showImgEvento, killImgEvento } = createConfig('imgEvento')

    const changeShowComponent = (component) => {
        const components = component.split('-')
        let currentKillComponent = killComponent

        for (const component of components) {
            currentKillComponent = currentKillComponent.replace(component, '')
        }

        setKillComponent(currentKillComponent)
        setShowComponent(component)
    }

    const changeKillComponent = (component) => {
        setKillComponent(component)
    }

    const value = {
        showComponent,
        showAbaWeb,
        killAbaWeb,
        showTratarEvento,
        killTratarEvento,
        changeShowComponent,
        changeKillComponent,
        showLivroAta,
        killLivroAta,
        showOrdemServico,
        killOrdemServico,
        showHistoricoEventos,
        killHistoricoEventos,
        showAcessosAoVivo,
        killAcessosAoVivo,
        showNobreak,
        killNobreak,
        showCaixaAgua,
        killCaixaAgua,
        showVisitantes,
        killVisitantes,
        showOcorrencias,
        killOcorrencias,
        showRonda,
        killRonda,
        showImgEvento,
        killImgEvento,
        showEntregasTab,
        killEntregasTab
    }

    return (
        <ChangeComponentContext.Provider value={value}>
            <>
                {children}
            </>
        </ChangeComponentContext.Provider>
    )
}
